module.exports = __webpack_public_path__ + "0.2.26/img/icon_touxiangb.25c18ef1.png";